const Background = () => {
    return ( 
        <>
            <div className="background1" />
        </>
     );
}
 
export default Background;